import styled from 'styled-components'
import { SIZES } from '../../../styles/theme'

export const AbstractEmailButton = styled.button`
  display: grid;
  grid-template-columns: 55px 1fr;
  grid-template-rows: 1fr 1fr;
  font-size: 1.15em;
  grid-gap: 2px;
  color: white;
  background: transparent;
  border: none;
  text-align: left;

  p {
    margin: 0;
  }

  .email {
    font-size: 12px;
    font-weight: 200;
  }

  svg {
    grid-row: span 2;
    align-self: center;
    height: 40px;
    fill: #e2e2e2;
  }

  &:hover {
    color: #ffcc5a;
    svg {
      fill: #ffcc5a;
    }
  }

  ${SIZES.mobile} {
    grid-template-columns: 50px 1fr;
    margin-bottom: 20px;

    svg {
      height: 25px;
    }
  }
`
